import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import { useRoute, useRouter } from '#app/composables/router';
import { decideLicenseLocked, useAuth } from '#layers/access/public';
import { useSystemInfo } from '#layers/base/public';
import { isUnderTest } from '~/utils/env/is-under-test';
import { isGuestOrPublicRoute } from '~/utils/routes';

/**
 * Reactive counterpart to `3.license-locked.global`: that middleware only decides
 * on navigation, so a license that flips to `locked` in place — a manual refresh
 * on the license settings panel, or grace lapsing mid-session — would otherwise
 * leave the user sitting on a stale screen until they happen to navigate.
 */
export function useLicenseLockRedirect() {
	const route = useRoute();
	const router = useRouter();
	const systemInfo = useSystemInfo();
	const { loggedIn } = storeToRefs(useAuth());

	watch(() => systemInfo.license.status, (status) => {
		const redirect = decideLicenseLocked({
			isUnderTest: isUnderTest(),
			isGuestOrPublicRoute: isGuestOrPublicRoute(route),
			isLockPage: route.name === 'license.locked',
			loggedIn: loggedIn.value,
			licenseStatus: status,
			redirectPath: route.fullPath,
		});

		if (redirect) router.replace(redirect);
	});
}
